export const loadState = () => {
  try {
    return JSON.parse(localStorage.getItem('store')) || {};
  } catch (err) {
    console.log('Ошибка загрузки localStorage: ', err);
    return null;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('store', serializedState);
  } catch (err) {
    console.log('Ошибка сохранения localStorage: ', err);
  }
};
